import styled from 'styled-components';
import { Link } from 'react-router-dom';


export const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    justify-content: space-between; 
    margin: auto;
    align-items: center;
`;


export const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    max-width:300px;
`;

export const NavContainer = styled.div`
    display: flex;
    flex-direction: column;

    align-items: center;
`;

export const OptionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0px 20px 0px 0px;
    flex-wrap: wrap;
    
`;

export const OptionLink = styled(Link)`
    padding: 10px 15px;
    cursor: pointer;
    color: grey;
    text-decoration: none;
`;

export const OptionText = styled.div`
    padding: 10px 15px;
    color: #003399;
    text-decoration: bold;
    align-items: right;
    font-size: 20px;
`;